export const PLUS_PLAN_PRICE = {
  monthly: 149,
  setUpFee: 399,
  currency: 'GBP',
  locale: 'en-GB',
} as const;

export function formatPlusPrice(amount: number): string {
  return new Intl.NumberFormat(PLUS_PLAN_PRICE.locale, {
    style: 'currency',
    currency: PLUS_PLAN_PRICE.currency,
    maximumFractionDigits: 0,
  }).format(amount);
}
